import { doAttention } from '@/attention';
export function bounce(el, duration = undefined, options = {}) {
    return doAttention(el, 'bounce', duration, options);
}
//# sourceMappingURL=bounce.js.map